/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Logistics_No_ChangesInputs */

const en_orders_logistics_no_changes = /** @type {(inputs: Orders_Logistics_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No logistics changes to save.`)
};

const es_orders_logistics_no_changes = /** @type {(inputs: Orders_Logistics_No_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay cambios de logistica para guardar.`)
};

/**
* | output |
* | --- |
* | "No logistics changes to save." |
*
* @param {Orders_Logistics_No_ChangesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_logistics_no_changes = /** @type {((inputs?: Orders_Logistics_No_ChangesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Logistics_No_ChangesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_logistics_no_changes(inputs)
	return es_orders_logistics_no_changes(inputs)
});